import { styled } from '@gogame/components';
import Box from '@gogame/ui/Box';
import View from '@gogame/ui/View';

export const ScrollContainer = styled(Box)({
  overflowY: 'scroll',
  paddingLeft: '16px',
  flex: 1,
  display: 'flex',
  minHeight: '80px',
  flexDirection: 'column',
});

export const LoadingContainer = styled(View)({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  minHeight: 0,
});

export const NewChatContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  flex: 1,
});
